// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3yLXu","row":"Node_row__2U8NJ","label":"Node_label__1RXnt","footer":"Node_footer__qf_FM"};